<template>
  <nav v-if="showNavbar" class="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow-sm enhanced-navbar">
    <div class="container-fluid container">
      <a href="https://soulintec.com/" target="_blank">
        <img src="/logo.png" alt="Company Logo" class="company-logo" />
      </a>

      <a href="/" class="navbar-brand enhanced-brand">
        <img src="/s.png" alt="Logo" class="logo" />
        <span class="brand-text">SOULMAINT</span>
      </a>

      <button class="navbar-toggler enhanced-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse enhanced-collapse" id="navbarNav">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 enhanced-nav-list">
          <li class="nav-item enhanced-nav-item">
            <router-link to="/" class="nav-link enhanced-nav-link" aria-current="page">
               Dashboard
            </router-link>
          </li>

          <!-- Reports Dropdown - للمديرين والإدارة فقط -->
          <li v-if="hasRole(['super_admin', 'admin', 'manager'])" class="nav-item dropdown enhanced-nav-item">
            <a class="nav-link dropdown-toggle enhanced-nav-link" href="#" id="reportsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              Reports
            </a>
            <ul class="dropdown-menu enhanced-dropdown-menu" aria-labelledby="reportsDropdown">
              <li><h6 class="dropdown-header">Assets</h6></li> 
              <li><router-link to="/reports/assets-by-site" class="dropdown-item enhanced-dropdown-item">Assets by Site</router-link></li>
              <li><router-link to="/reports/assets-by-department" class="dropdown-item enhanced-dropdown-item">Assets by Department</router-link></li>
              <li><router-link to="/reports/assets-by-location" class="dropdown-item enhanced-dropdown-item">Assets by Location</router-link></li>
              <li><router-link to="/reports/assets-by-category" class="dropdown-item enhanced-dropdown-item">Assets by Category</router-link></li>
              <li><hr class="dropdown-divider"></li> 
              <li><h6 class="dropdown-header">Workorders</h6></li> 
              <li><router-link to="/reports/openwo" class="dropdown-item enhanced-dropdown-item">Open WorkOrders</router-link></li>
              <li><router-link to="/reports/closedwo" class="dropdown-item enhanced-dropdown-item">Closed WorkOrders</router-link></li>
              <li><router-link to="/workorders-by-asset" class="dropdown-item enhanced-dropdown-item">Work Orders By Asset</router-link></li>
              <li><router-link to="/asset-breakdown-analysis" class="dropdown-item enhanced-dropdown-item">Breakdown Analysis</router-link></li>
            </ul>
          </li>

          <li class="nav-item enhanced-nav-item">
            <router-link to="/about" class="nav-link enhanced-nav-link">
             About
            </router-link>
          </li>
        </ul>

        <!-- User Menu على اليمين -->
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
            
          <!-- Admin Dropdown - للإدارة فقط -->
          <!-- <li v-if="hasRole(['super_admin', 'admin','manager'])" class="nav-item dropdown enhanced-nav-item">
            <a class="nav-link dropdown-toggle enhanced-nav-link admin-menu" href="#" id="adminDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
               Admin
            </a>
            <ul class="dropdown-menu enhanced-dropdown-menu" aria-labelledby="adminDropdown">
              <li><h6 class="dropdown-header">Administration</h6></li>
              <li>
                <router-link to="/control-panel" class="dropdown-item enhanced-dropdown-item">
                   Control Panel
                </router-link>
              </li>
            </ul>
          </li> -->

          <!-- Database Switcher - للادمن والسوبر ادمن فقط -->
          <li v-if="hasRole(['super_admin'])" class="nav-item enhanced-nav-item">
            <DatabaseSwitcher @database-changed="onDatabaseChanged" />
          </li>

          <li v-if="hasRole(['user','admin','manager'])" class="nav-item enhanced-nav-item" style="pointer-events: none; opacity: 0.6;">
            <DatabaseSwitcher @database-changed="onDatabaseChanged" />
          </li>

          <!-- User Menu -->
          <li class="nav-item dropdown enhanced-nav-item">
            <a class="nav-link dropdown-toggle enhanced-nav-link user-menu" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
              👤 {{ currentUser?.username || 'User' }}
              <span v-if="hasRole(['super_admin'])" class="badge bg-danger ms-1">Super Admin</span>
              <span v-else-if="hasRole(['admin'])" class="badge bg-warning ms-1">Admin</span>
              <span v-else-if="hasRole(['manager'])" class="badge bg-info ms-1">Manager</span>
              <span v-else class="badge bg-secondary ms-1">User</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end enhanced-dropdown-menu" aria-labelledby="userDropdown">
              <li>
                <router-link to="/profile" class="dropdown-item enhanced-dropdown-item">
                   Profile
                </router-link>
              </li>
              <li><hr class="dropdown-divider"></li>
              <li>
                <button class="dropdown-item enhanced-dropdown-item logout-btn" @click="handleLogout">
                   Logout
                </button>
              </li>
            </ul>
          </li>
        </ul>

        
      </div>
    </div>
  </nav>
</template>

<script>
import DatabaseSwitcher from './DatabaseSwitcher.vue';

export default {
  name: 'Navbar',
  components: {
    DatabaseSwitcher
  },
  
  computed: {
    currentUser() {
      const userData = localStorage.getItem('user');
      return userData ? JSON.parse(userData) : null;
    },
    
    isAuthenticated() {
      return !!localStorage.getItem('token');
    },
    
    showNavbar() {
      // إخفاء الـ navbar في شاشة اللوجين فقط
      return this.$route.name !== 'Login' && this.isAuthenticated;
    }
  },
  
  methods: {
    handleLogout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.$router.push('/login');
      console.log('✅ Logout successful');
    },
    
    hasRole(roles) {
      const user = this.currentUser;
      if (!user || !user.roles) return false;
      
      return roles.some(role => user.roles.includes(role));
    },
    
    getUserRoleBadge() {
      const user = this.currentUser;
      if (!user || !user.roles) return '';
      
      if (user.roles.includes('super_admin')) return 'Super Admin';
      if (user.roles.includes('admin')) return 'Admin';
      if (user.roles.includes('manager')) return 'Manager';
      return 'User';
    },
    
    onDatabaseChanged(dbName) {
      console.log('Database changed to:', dbName);
      // هنا تقدر تعمل أي حاجة تانيه لما الداتابيز تتغير
      // مثلاً تعمل refresh للصفحة أو تظهر notification
      if (this.$notify) {
        this.$notify({
          title: 'Database Switched',
          message: `Connected to ${dbName} successfully`,
          type: 'success'
        });
      }
      
      // نعمل refresh للصفحة بعد ثانيتين
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  },
  
  mounted() {
    console.log('🔄 Navbar mounted - User:', this.currentUser);
    console.log('🎭 User roles:', this.currentUser?.roles);
    console.log('👑 Has Admin role:', this.hasRole(['super_admin', 'admin']));
    console.log('👔 Has Manager role:', this.hasRole(['manager']));
  }
}
</script>

<style scoped>
/* Custom styles for the enhanced navbar */
.enhanced-navbar {
    border-bottom: 3px solid #007bff;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 0.5rem 0;
}

.enhanced-brand {
    font-size: 1.6rem;
    font-weight: 700;
    color: #333;
    padding: 0.5rem 1rem;
    transition: color 0.3s ease;
    display: flex;
    align-items: center;
    text-decoration: none;
}

.enhanced-brand:hover {
    color: #0056b3;
    text-decoration: none;
}

.logo {
    height: 40px;
    width: auto;
    margin-right: 10px;
    transition: transform 0.3s ease-in-out;
}

.enhanced-brand:hover .logo {
    transform: scale(1.1);
}

.enhanced-toggler {
    border-color: rgba(0, 0, 0, 0.1);
}

.enhanced-nav-item {
    margin: 0 8px;
}

.enhanced-nav-link {
    color: #555;
    font-weight: 500;
    padding: 0.7rem 1rem;
    position: relative;
    transition: color 0.3s ease, background-color 0.3s ease;
    overflow: hidden;
    text-decoration: none;
    display: block;
}

.enhanced-nav-link:hover {
    color: #007bff;
    background-color: rgba(0, 123, 255, 0.08);
    text-decoration: none;
}

.router-link-exact-active:not(.dropdown-toggle) {
  color: #007bff !important;
  font-weight: 700;
  background-color: rgba(0, 123, 255, 0.15);
}

.router-link-exact-active.dropdown-toggle {
    color: #007bff !important;
    font-weight: 700;
    background-color: rgba(0, 123, 255, 0.15);
}

.enhanced-nav-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #007bff;
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 0.3s ease-out;
}

.enhanced-nav-link:not(.dropdown-toggle):hover::after,
.router-link-exact-active:not(.dropdown-toggle)::after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

.enhanced-dropdown-menu {
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    padding: 8px 0;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.enhanced-dropdown-item {
    color: #333;
    padding: 10px 20px;
    transition: background-color 0.2s ease, color 0.2s ease;
    text-decoration: none;
    display: block;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
    cursor: pointer;
}

.enhanced-dropdown-item:hover {
    background-color: #e9ecef;
    color: #007bff;
    text-decoration: none;
}

.enhanced-dropdown-item.router-link-exact-active {
    color: #007bff !important;
    background-color: #cfe2ff !important;
    font-weight: 700;
}

.dropdown-divider {
    border-top: 1px solid #e9ecef;
    margin: 0.5rem 0;
}

/* Company Logo */
.company-logo {
  height: 50px;
  width: auto;
  margin-right: 15px;
  transition: transform 0.3s ease;
  cursor: pointer;
}

.company-logo:hover {
  transform: scale(1.1);
}

/* Database Switcher Styles */
.database-switcher {
  min-width: 180px;
  margin-left: 10px;
}

.database-switcher .form-select {
  height: 38px;
  border: 1px solid #007bff;
  border-radius: 20px;
  background: rgba(0, 123, 255, 0.1);
  color: #007bff;
  font-weight: 500;
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.database-switcher .form-select:hover {
  background: rgba(0, 123, 255, 0.2);
  border-color: #0056b3;
}

.database-switcher .form-select:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border-color: #007bff;
}

/* Admin and User Menu Styles */
.admin-menu {
  background: rgba(255, 193, 7, 0.1);
  border-radius: 20px;
  color: #856404 !important;
  font-weight: 600;
}

.admin-menu:hover {
  background: rgba(255, 193, 7, 0.2);
  color: #664d03 !important;
}

.user-menu {
  background: rgba(0, 123, 255, 0.1);
  border-radius: 20px;
  margin-left: 10px;
}

.user-menu:hover {
  background: rgba(0, 123, 255, 0.2);
}

.badge {
  font-size: 0.6rem;
  padding: 0.2rem 0.4rem;
  font-weight: 600;
}

.badge.bg-danger {
  background: linear-gradient(45deg, #dc3545, #c82333) !important;
}

.badge.bg-warning {
  background: linear-gradient(45deg, #ffc107, #e0a800) !important;
  color: #000 !important;
}

.badge.bg-info {
  background: linear-gradient(45deg, #17a2b8, #138496) !important;
}

.badge.bg-secondary {
  background: linear-gradient(45deg, #6c757d, #545b62) !important;
}

.logout-btn {
  color: #dc3545 !important;
}

.logout-btn:hover {
  color: #fff !important;
  background-color: #dc3545 !important;
}

.navbar-nav .dropdown-menu-end {
  right: 0;
  left: auto;
}

/* Responsive adjustments */
@media (max-width: 991.98px) {
    .enhanced-navbar .container-fluid {
        flex-direction: column;
        align-items: flex-start;
    }

    .enhanced-brand {
        margin-bottom: 10px;
    }

    .enhanced-collapse {
        width: 100%;
    }

    .enhanced-nav-list {
        flex-direction: column;
        width: 100%;
    }

    .enhanced-nav-item {
        margin: 0;
        width: 100%;
    }

    .enhanced-nav-link {
        padding: 12px 15px;
        border-bottom: 1px solid #eee;
    }

    .enhanced-nav-link::after {
        display: none;
    }

    .enhanced-nav-link:hover {
        background-color: rgba(0, 123, 255, 0.1);
    }

    .router-link-exact-active:not(.dropdown-toggle) {
        background-color: rgba(0, 123, 255, 0.15) !important;
    }
    
    .router-link-exact-active.dropdown-toggle {
        background-color: rgba(0, 123, 255, 0.15) !important;
    }

    .dropdown-item {
        padding-left: 30px;
        border-bottom: none;
    }
    
    .dropdown-item.router-link-exact-active {
        background-color: rgba(0, 123, 255, 0.2) !important;
    }

    .enhanced-dropdown-menu {
        position: static !important;
        float: none !important;
        width: 100%;
        margin-top: 0 !important;
        border: none;
        box-shadow: none;
        animation: none;
    }

    .navbar-collapse.show .dropdown-menu {
        display: block !important;
    }
    
    .user-menu, .admin-menu {
        margin-left: 0;
        margin-top: 10px;
    }
    
    .database-switcher {
        margin-left: 0;
        margin-top: 10px;
        width: 100%;
    }
    
    .database-switcher .form-select {
        width: 100%;
    }
}

/* Print Styles */
@media print {
    .enhanced-navbar.fixed-top {
        position: static !important;
        box-shadow: none !important;
        background-color: #fff !important;
        border-radius: 0 !important;
        border-bottom: 3px solid #007bff;
    }
    
    .dropdown-toggle, 
    .dropdown-menu {
        display: none !important;
    }
    
    .enhanced-nav-item:has(> .dropdown-toggle) {
         display: none;
    }

    .enhanced-nav-link,
    .router-link-exact-active {
        color: #000 !important;
        background-color: transparent !important;
        font-weight: 500 !important;
    }
    
    .enhanced-nav-link::after {
        display: none !important;
    }
    
    .enhanced-brand {
         color: #000 !important;
    }
    
    .user-menu, .admin-menu {
        display: none !important;
    }
    
    .database-switcher {
        display: none !important;
    }
}
</style>